<template lang="pug">
    v-dialog(v-model="dialog" persistent max-width="400")
        v-card(class="menu")
            v-toolbar(flat justify-end text-right)
                v-spacer
                v-toolbar-title(class="font-weight-bold primary--text mr-6") OTORISASI {{ validationValue }}
                v-spacer
            v-card-text(class="font-weight-medium text-center mt-2" v-if="validationValue == 'OTP'")
                v-form(ref="form" id="form" @submit.prevent="doOK" lazy-validation)
                    div(class="font-weight-bold primary--text justify-center center-component" style="text-align: center") Kirim Melalui
                    v-layout(justify-center class="center-component")
                        v-radio-group(dense v-model="sendBy" row )
                            v-radio(label="Email" value="EMAIL" color="primary")
                            v-radio(label="SMS" value="PHONE" color="primary")
                    div(v-if="countdown > 0" justify-center class="text-center caption font-weight-bold primary--text") Kirim Ulang OTP Setelah {{ stCountdown }}
                    div(v-else justify-center class="text-center menu-btn")
                        v-btn(color="success" @click="sendOtp") Kirim OTP
                            v-icon(small) mdi-send
                    v-layout(justify-center)
                        f-otpbox(v-model="otp" label="Masukan Kode OTP" :rules="[v => !!v || 'Masukan Kode OTP', v => v.length == 6 || 'OTP Harus 6 Digit' ]" v-on:finish="doOK")
            v-card-text(class="font-weight-medium text-center mt-2" v-else-if="validationValue == 'PIN'")
                v-layout(wrap v-if="userDetail && userDetail.user.firstPin")
                    v-stepper(v-model="step")
                        v-stepper-items
                            v-stepper-content(step = "1")
                                v-layout(justify-center)
                                    f-otpbox(v-model="change.newPin" label="PIN Baru" v-on:finish="step='2'")
                            v-stepper-content(step = "2")
                                v-layout(justify-center)
                                    f-otpbox(v-model="change.confirmPin" label="Konfirmasi PIN" v-on:finish="validateChangePin")
                    
                v-layout(wrap justify-center v-else)
                    f-otpbox(v-model="otp" label="Masukan PIN" :rules="[v => !!v || 'Masukan PIN', v => v.length == 6 || 'PIN Harus 6 Digit' ]" v-on:finish="pinValidation")
            v-card-actions(class="justify-center menu-btn")
                v-btn(class="mb-3" @click="doCancel") Kembali
                    v-icon(small) mdi-arrow-left-circle
                v-btn(v-if="validationValue == 'OTP'" class="mb-3" color="btnprimary white--text" type="submit" form="form") Proses
                    v-icon(small) mdi-arrow-right-circle
</template>
<script>
import localforage from "localforage";
export default {
    name: "FDialogOtp",
    props: ["value", "events"],
    data() {
        return {
            dialog: false,
            initOtp: 30,
            countdown: 30,
            otp: "",
            stCountdown: "",
            sendBy: "EMAIL",
            userDetail: null,
            step: "1",
            change: {
                username: "",
                newPin: "",
                confirmPin: ""
            },
        }
    },
    mounted() {
        this.$session.userDetail().then(item => {
            this.initOtp = item.maxSecondsReRequestOtp || 30;
            this.userDetail = item;
            this.doInit(this.value);
        })
    },
    watch: {
        value(val){
            this.doInit(val);
        }
    },
    computed: {
        validationValue() {
            if (this.userDetail) {
                return this.userDetail.user.validation;
            }else {
                return "OTP";
            }
        }
    },
    methods: {
        doInit(values){
            this.dialog = values ? values : false;
            this.countdown = 0;
            this.otp = "";
            this.step = "1";
            this.change = {
                username: this.userDetail ? this.userDetail.username : "",
                newPin: "",
                confirmPin: ""
            };
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
            if (this.dialog && this.dialog == true && 
                (!this.validationValue || this.validationValue == 'NON' || this.validationValue == 'NONE')) {
                this.noneValidation();
            }
        },
        sendOtp() {
            if (this.dialog) {
                this.countdown = this.initOtp;
                this.$http.get("/api/transaction/otp-request", {
                    params: {
                        sendBy: this.sendBy
                    }
                }).then(success => {
                    this.countdownTimer();
                }, err => {
                    this.$message.error(err.response.data.message);
                });
            }
        },
        countdownTimer() {
            if (this.dialog) {
                if (this.countdown > 0) {
                    setTimeout(() => {
                        this.stCountdown = ("0" + Math.floor(this.countdown/60)).slice(-2) + 
                            ":" + ("0" + (this.countdown%60)).slice(-2);
                        this.countdown -= 1;
                        this.countdownTimer();
                    }, 1000);
                }
            }
        },
        doOK() {
            if (this.$refs.form.validate()) {
                this.$emit("otp", this.otp);
                this.$emit("dialog", false);
                if (this.events) {
                    this.$emit(this.events);
                }
            }
        },
        doCancel() {
            this.$emit("dialog", false);
        },
        pinValidation() {
            this.$emit("otp", this.otp);
            this.$emit("dialog", false);
            if (this.events) {
                this.$emit(this.events);
            }
        },
        noneValidation() {
            this.$emit("otp", '000000');
            this.$emit("dialog", false);
            if (this.events) {
                this.$emit(this.events);
            }
        },
        validateChangePin(){
            if (this.change.newPin !== this.change.confirmPin) {
                this.$message.error("Konfirmasi PIN tidak sesuai")
            }else{
                this.doChangePin();
            }
            
        },
        doChangePin(){
            this.$progress.show(true);
            this.$http.post("/api/user/change-pin", this.change)
                .then(success => {
                    this.$message.success("Anda berhasil membuat pin baru.");
                    
                    this.userDetail.user.firstPin = false;
                    localforage.setItem("userDetailIbk", this.userDetail);
                    this.otp = "";
                }, err => {
                    this.$message.error(err.response.data.message)
                }).finally(() => this.$progress.show(false));
        },
    },
}
</script>

<style>
.otp .v-input--selection-controls {
    margin-top: 4px;
}
.otp .v-input--selection-controls .v-radio > .v-label{
    font-size: 15px !important;
}
</style>
